import React from 'react';

const Index = () => {
  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="22" viewBox="0 0 24 22" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M17.545 4L12 0L6.455 4L0 0V18L6.455 22L12 18L17.545 22L24 18V0L17.545 4ZM7 6.073L11 3.187V16.255L7 19.14V6.073ZM17 6.073L13 3.187V16.256L17 19.141V6.073ZM2 3.592L6 6.071V19.365L2 16.886V3.592ZM18 19.366L22 16.887V3.592L18 6.071V19.366Z" fill="#333333"/>
      </svg>
    </>
  );
};

export default Index;